module.exports = __webpack_public_path__ + "static/media/SFST_1-1022w.92e01b53.webp";